// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b5d6e251","72":"73f81e21","227":"cd528814","356":"13678bea","591":"66fdfd95","691":"af42fc5d"}[chunkId] + ".chunk.js";
};